import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-submit"
export default class extends Controller {
  static targets = ["input", "submitter"]

  connect() {
  }

  inputTargetConnected(element) {
    element.addEventListener("change", (e) => {
      e.preventDefault(); 
      this.submitForm();
    })
  }

  submitterTargetConnected(element) {
    element.addEventListener("click", this.submitForm.bind(this))
  }

  submitForm() {
    if (!this.hasInputTarget) return
    const form = this.inputTarget.form
    if (form) form.submit()
  }
}